import { defineComponent, h, VNodeChildren } from 'vue';
import { du } from '@/ui/i18n/i18n';
import { VNodeData } from 'vue/types/vnode.d';
import { ScimErrorLog } from '@/services/api/resources/sso-configuration';

interface CreatedAtProps {
  log: ScimErrorLog;
}

export const CreatedAt = defineComponent<CreatedAtProps>({
  name: 'CreatedAt',
  props: ['log'],
  setup(props, context) {
    return function render() {
      return h('div', { class: 'sso-scim-error-logs__created-at' }, [
        context.slots.left ? context.slots.left() : null,
        du(props.log.createdAt, 'shortDateTime'),
      ]);
    };
  },
});

export function createdAt(data: VNodeData & { props: CreatedAtProps }, children: VNodeChildren = []) {
  return h(CreatedAt, data, children);
}
